export const isEmpty = (value: string | undefined) => {
  if (!value) return true
  return value == '<p><br></p>'
}
